import {renderAboutBarTextColor} from "../../../controllers/aboutScreen/AboutTabBarController";

export default function AboutDesktopTabBarItemText({text, isSelected, isHovered}) {
    // Used in AboutDesktopTabBarItem to show
    // section title text

    // BUILD
    return (
        <div className={"h-full block whitespace-nowrap"}>
            <span className={`text-[18px] lg:text-[20px] font-medium  ${renderAboutBarTextColor(isSelected, isHovered)}`}>
                {text}
            </span>
        </div>
    );
}